import { render, staticRenderFns } from "./DetailPrestages.vue?vue&type=template&id=38304731&scoped=true&"
import script from "./DetailPrestages.vue?vue&type=script&lang=js&"
export * from "./DetailPrestages.vue?vue&type=script&lang=js&"
import style0 from "./DetailPrestages.vue?vue&type=style&index=0&id=38304731&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38304731",
  null
  
)

export default component.exports